import React from "react";

export default function AIMLGenAIImg(props) {
  const theme = props.theme;
  return (
    <svg
      id="aiml-genai-illustration"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 900 620"
    >
      <title>AI ML GenAI</title>
      <ellipse
        cx="450"
        cy="590"
        rx="320"
        ry="22"
        fill={theme.compImgHighlight}
      />

      {/* Central neural / LLM orb */}
      <circle
        cx="450"
        cy="280"
        r="92"
        fill={theme.imageHighlight}
        opacity="0.18"
      />
      <circle
        cx="450"
        cy="280"
        r="68"
        fill={theme.imageHighlight}
        opacity="0.28"
      />
      <circle cx="450" cy="280" r="48" fill={theme.imageHighlight} />
      <circle cx="450" cy="280" r="28" fill={theme.accentColor} opacity="0.9" />
      <circle cx="450" cy="280" r="12" fill="#fff" opacity="0.95" />

      {/* Neural nodes */}
      <g fill={theme.text}>
        <circle cx="250" cy="160" r="14" />
        <circle cx="180" cy="280" r="12" />
        <circle cx="250" cy="400" r="14" />
        <circle cx="650" cy="160" r="14" />
        <circle cx="720" cy="280" r="12" />
        <circle cx="650" cy="400" r="14" />
        <circle cx="360" cy="120" r="10" />
        <circle cx="540" cy="120" r="10" />
        <circle cx="360" cy="440" r="10" />
        <circle cx="540" cy="440" r="10" />
      </g>

      {/* Connection lines */}
      <g
        stroke={theme.imageHighlight}
        strokeWidth="2.5"
        fill="none"
        opacity="0.75"
      >
        <line x1="264" y1="168" x2="402" y2="250" />
        <line x1="192" y1="280" x2="402" y2="280" />
        <line x1="264" y1="392" x2="402" y2="310" />
        <line x1="636" y1="168" x2="498" y2="250" />
        <line x1="708" y1="280" x2="498" y2="280" />
        <line x1="636" y1="392" x2="498" y2="310" />
        <line x1="370" y1="128" x2="420" y2="236" />
        <line x1="530" y1="128" x2="480" y2="236" />
        <line x1="370" y1="432" x2="420" y2="324" />
        <line x1="530" y1="432" x2="480" y2="324" />
      </g>

      {/* Accent pulses on nodes */}
      <g fill={theme.accentColor}>
        <circle cx="250" cy="160" r="5" />
        <circle cx="650" cy="160" r="5" />
        <circle cx="250" cy="400" r="5" />
        <circle cx="650" cy="400" r="5" />
        <circle cx="180" cy="280" r="4" />
        <circle cx="720" cy="280" r="4" />
      </g>

      {/* Left: RAG / document stack */}
      <g>
        <rect
          x="70"
          y="200"
          width="90"
          height="112"
          rx="8"
          fill={theme.compImgHighlight}
        />
        <rect
          x="82"
          y="216"
          width="66"
          height="8"
          rx="2"
          fill={theme.text}
          opacity="0.55"
        />
        <rect
          x="82"
          y="234"
          width="52"
          height="6"
          rx="2"
          fill={theme.text}
          opacity="0.35"
        />
        <rect
          x="82"
          y="248"
          width="58"
          height="6"
          rx="2"
          fill={theme.text}
          opacity="0.35"
        />
        <rect
          x="82"
          y="262"
          width="44"
          height="6"
          rx="2"
          fill={theme.text}
          opacity="0.35"
        />
        <rect
          x="82"
          y="284"
          width="40"
          height="10"
          rx="3"
          fill={theme.imageHighlight}
        />
      </g>

      {/* Right: chat / GenAI bubble */}
      <g>
        <path
          d="M760 210 h100 a14 14 0 0 1 14 14 v70 a14 14 0 0 1 -14 14 h-70 l-22 22 v-22 h-8 a14 14 0 0 1 -14 -14 v-70 a14 14 0 0 1 14 -14 z"
          fill={theme.accentColor}
        />
        <rect
          x="778"
          y="236"
          width="70"
          height="7"
          rx="2"
          fill="#fff"
          opacity="0.9"
        />
        <rect
          x="778"
          y="252"
          width="54"
          height="6"
          rx="2"
          fill="#fff"
          opacity="0.65"
        />
        <rect
          x="778"
          y="266"
          width="62"
          height="6"
          rx="2"
          fill="#fff"
          opacity="0.65"
        />
      </g>

      {/* Bottom: voice / waveform strip */}
      <g fill={theme.imageHighlight}>
        <rect x="330" y="500" width="6" height="28" rx="2" opacity="0.45" />
        <rect x="344" y="488" width="6" height="52" rx="2" opacity="0.7" />
        <rect x="358" y="476" width="6" height="76" rx="2" />
        <rect x="372" y="492" width="6" height="44" rx="2" opacity="0.8" />
        <rect x="386" y="468" width="6" height="92" rx="2" />
        <rect x="400" y="484" width="6" height="60" rx="2" opacity="0.75" />
        <rect x="414" y="472" width="6" height="84" rx="2" />
        <rect x="428" y="496" width="6" height="36" rx="2" opacity="0.55" />
        <rect x="442" y="480" width="6" height="68" rx="2" opacity="0.85" />
        <rect x="456" y="470" width="6" height="88" rx="2" />
        <rect x="470" y="490" width="6" height="48" rx="2" opacity="0.7" />
        <rect x="484" y="476" width="6" height="76" rx="2" />
        <rect x="498" y="500" width="6" height="28" rx="2" opacity="0.5" />
        <rect x="512" y="486" width="6" height="56" rx="2" opacity="0.75" />
        <rect x="526" y="494" width="6" height="40" rx="2" opacity="0.6" />
        <rect x="540" y="482" width="6" height="64" rx="2" opacity="0.8" />
        <rect x="554" y="504" width="6" height="20" rx="2" opacity="0.4" />
      </g>

      {/* Small floating chips */}
      <rect
        x="300"
        y="200"
        width="36"
        height="24"
        rx="4"
        fill={theme.compImgHighlight}
        stroke={theme.imageHighlight}
        strokeWidth="2"
      />
      <rect
        x="564"
        y="200"
        width="36"
        height="24"
        rx="4"
        fill={theme.compImgHighlight}
        stroke={theme.imageHighlight}
        strokeWidth="2"
      />
    </svg>
  );
}
